module.exports = __webpack_public_path__ + "img/bahrain.13d63817.jpg";